import React from "react";
import { SelectAppointmentTypeScreenWithBookingData } from "~/features/book-appointment/SelectAppointmentTypeScreen";

const Component = () => {
  return <SelectAppointmentTypeScreenWithBookingData />;
};

export default Component;
